import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import CountUpModule from "react-countup";
import Typography from "@mui/material/Typography";

// react-countup is CommonJS; under Vite 8's dev optimizer the default import resolves to the module
// namespace object rather than the component, so unwrap the real default export.
const CountUp = (CountUpModule as any).default || CountUpModule;

export interface ILargeCountTextProps {
    count: number | undefined;
    isPdf?: boolean;
    formatCount?: (count: number) => string;
}

function LargeCountText(props: ILargeCountTextProps) {
    const [counterValue, setCounterValue] = useState(0);
    const theme = useTheme();
    const textStyles = {
        fontSize: props.isPdf ? theme.typography.pxToRem(20) : theme.typography.pxToRem(48),
        lineHeight: 1,
    };
    const hasCountToShow = props.count !== undefined && props.count >= 0;

    return (
        <Typography variant="h1" sx={textStyles}>
            {hasCountToShow && (
                <Box>
                    {counterValue != props.count ? (
                        <CountUp end={props.count} duration={1} formattingFn={props.formatCount} onEnd={() => setCounterValue(props.count ?? 0)} />
                    ) : (
                        (props.formatCount?.(counterValue) ?? counterValue)
                    )}
                </Box>
            )}
        </Typography>
    );
}

export default LargeCountText;
